import router from '@/router';

/**
 * @param queryKey query name in the path that we know is an array
 * @returns {(string | null)[]|string[]|*[]} the value of the query as an array
 */
export function getRouteQueryAsArray(queryKey) {
  const value = router.currentRoute.query[queryKey];
  if (value === null || value === undefined || value === '') {
    return [];
  }

  if (!Array.isArray(value)) {
    return [value];
  }

  return value;
}

export function getRouteQueryAsNumber(queryKey) {
  const value = router.currentRoute.query[queryKey];
  if (value === null || value === undefined || value === '' || Array.isArray(value) || isNaN(value)) {
    return undefined;
  }

  return Number.parseInt(value);
}

export function updateRouteQuery(key, value) {
  router.replace(
    {
      path: router.currentRoute.path,
      query: {
        ...router.currentRoute.query,
        [key]: value === null ? undefined : value,
      },
    },
    () => {},
    (err) => {
      if (err && err.name !== 'NavigationDuplicated') {
        throw err;
      }
    },
  );
}
